import type { FaireProductEntity } from "../../entity_types/product";

export const p_6ujwjzxenu: FaireProductEntity = {
  token: "p_6ujwjzxenu",
  type: "product",
  name: "Lucille Square Bead Stretch Bracelet Brass Wholesale",
  brandToken: "b_dft137cxox",
  brandName: "INK + ALLOY",
  imageUrl:
    "https://cdn.faire.com/fastly/aa41353d442e57bd8542c3cb298c8357c51bea03907a82d3f20938b9165564e3.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/9461acffaa93e2903640d492e759b90528abf5bf375ce291944e961e7c48f0c3.jpeg",
    "https://cdn.faire.com/fastly/bfc1003352328c4792133683f04bd13ac5b333dec77f73fb2c8f6433e32fb505.jpeg",
  ],
  priceDollars: 6,
  description:
    "Square Beads, Sharp Style.\n• Polished brass with clean, modern edges\n• Stacks easy, stands out solo\n• From grocery runs to dinner plans\n\nLow-key luxe you’ll wear on repeat.\n\n--DETAILS--\n• Dimensions: 6.5” interior\n• Materials: Plated brass\n• Care: To extend the life of your accessories, store them in a dry place while swimming, showering, or working out.\n• Handmade by skilled artisans in India\n• These accessories are made by human hands. A slight variation in size and color is considered part of the beauty of these one-of-a-kind pieces.\n\nOriginal design copyright INK+ALLOY©\n",
  tags: [],
  msrpDollars: 15,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-07-23T05:53:36.343Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
